<template>
  <div :class="pageClass">
    <template v-if="tabelData.tabelData.length">
      <el-table
        :data="tabelData.tabelData"
        style="width: 100%"
        :class="[`${pageClass}-super-table`]"
        :header-cell-style="{ background: '#efefef', border: 'none' }"
      >
        <el-table-column label="试卷名称" width="200px">
          <template slot-scope="{ row }">
            <el-tooltip
              class="item"
              effect="dark"
              :content="row.title"
              placement="top-start"
            >
              <div class="paper-name">{{ row.title }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="学科">
          <template slot-scope="{ row }">
            <span class="st-icon-pandora">{{
              filterSubject(row.subjectId)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unCompleteCount" label="未答题数">
        </el-table-column>
        <el-table-column label="实际用时">
          <template slot-scope="{ row }">
            <span class="st-icon-pandora">{{
              formatSeconds(
                (row.timeUsed ? row.timeUsed : row.endTime - row.startTime) /
                  1000
              )
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试时间">
          <template slot-scope="{ row }">
            <span class="st-icon-pandora">{{ row.paperDuration }} 分钟</span>
          </template>
        </el-table-column>
        <el-table-column label="测评时间" width="250">
          <template slot-scope="{ row }">
            <span class="st-icon-pandora">{{
              row.endTime
                ? new Date(row.endTime).format("yyyy.MM.dd hh:mm:ss")
                : "暂无数据"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column class="" fixed="right" label="操作">
          <template slot-scope="{ row }">
            <el-button
              @click="click_continue(row.id, row.paperId, row.appId)"
              type="text"
              >继续测评</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <topic-page
        @currentChange="currentIndex"
        :page-index="tabelData.params.pageIndex"
        :total-count="tabelData.totalCount"
      ></topic-page>
    </template>
    <template v-else>
      <div class="nocountent">
        <img src="../../../assets/images/home/nocountent.jpg" alt="" />
        <p>暂无未完成数据</p>
      </div>
    </template>
  </div>
</template>

<script>
import topicPage from "../../../../src/components/page/index";
import { resource } from "../../../mixins/my_personal";
// import solutionQuestion from '@/components/paper/question/concrete_question/solution_question';
export default {
  name: "uncomplete",
  mixins: [resource],
  data() {
    return {
      pageClass: "evaluationTabel",
    };
  },
  props: {
    tabelData: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  computed: {
    filterSubject() {
      return function (data) {
        return this.subject[data];
      };
    },
  },
  components: {
    topicPage,
  },
  methods: {
    formatSeconds(value) {
      var theTime = parseInt(value); // 秒
      var theTime1 = 0; // 分
      var theTime2 = 0; // 小时
      // alert(theTime);
      if (theTime > 60) {
        theTime1 = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        // alert(theTime1+"-"+theTime);
        if (theTime1 > 60) {
          theTime2 = parseInt(theTime1 / 60);
          theTime1 = parseInt(theTime1 % 60);
        }
      }
      var result = "" + parseInt(theTime) + "秒";
      if (theTime1 > 0) {
        result = "" + parseInt(theTime1) + "分" + result;
      }
      if (theTime2 > 0) {
        result = "" + parseInt(theTime2) + "小时" + result;
      }
      return result;
    },
    currentIndex(value) {
      this.$emit("changeIndexs", value);
    },
    click_continue(id, paperId, appId) {
      if (appId == 100) {
        this.$router.push({
          path: "/continue_evaluation_zj",
          query: {
            id: id,
            paper_id: paperId,
            app_id: appId,
            question_type: -1,
            origin: "evalution",
          },
        });
      } else {
        this.$router.push({
          path: "/continue_evaluation",
          query: { id: id, paper_id: paperId, app_id: appId },
        });
      }
    },
  },
  created() {
    console.log("this.tabelData ===>", this.tabelData);
  },
};
</script>
<style lang="stylus" scoped>
.nocountent {
  width: 400px;
  margin: 0 auto;
  margin-top: 50px;
  position: relative;

  img {
    width: 100%;
  }

  p {
    color: #a9a9a9;
    font-size: 18px;
    width: 100%;
    position: absolute;
    bottom: 5px;
    text-align: right;
    padding-right: 40px;
  }
}

.evaluationTabel {
  padding: 0 60px;
  padding-bottom: 30px;

  .no-content {
    width: 100%;
    text-align: center;
    color: #7a8f9a;
    background-color: #ffffff;
    line-height: 160px;
  }

  /deep/ &-super-table {
    right: -2px;

    .paper-name {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
    }

    .el-button--text {
      font-size: 16px;
    }
  }

  /deep/ .el-table th {
    text-align: center;
  }

  /deep/ .el-table td {
    text-align: center;
    padding: 10px 0 !important;
  }

  & >>> .el-table {
    th >.cell {
      font-size: 16px;
      font-weight: 800;
    }

    .cell {
      font-size: 16px;
      color: #3c3c3c;
    }
  }

  & >>> .el-table::before {
    /* 去除下边框 */
    height: 0;
  }
}
</style>